import React, { Component } from "react";
export default class Support extends Component {
  render() {
    return <div>support@herozonevr.com +32 487 589 509</div>;
  }
}
